import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
// @mui
import { Stack, Typography, Grid, Box } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import parse from 'html-react-parser';

import CircularProgress from '@mui/material/CircularProgress';
import { getFirestore, collection, addDoc, serverTimestamp, setDoc, doc, Timestamp, getDocs, query, where   } from "firebase/firestore";
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from "firebase/database";
import { initializeApp } from "firebase/app";

// ----------------------------------------------------------------------

const firebaseConfig = {
  apiKey: "AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak",
  authDomain: "onetweb-e3d8e.firebaseapp.com",
  databaseURL: "https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "onetweb-e3d8e",
  storageBucket: "onetweb-e3d8e.firebasestorage.app",
  messagingSenderId: "60910494595",
  appId: "1:60910494595:web:2dc6bf320d67371af04cb6",
  measurementId: "G-0ZTHXZBNP9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


const rtdb = getDatabase(app);


export default function HomePage() {

  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);

  const theme = useTheme();
      const matches = useMediaQuery(theme.breakpoints.up('md'));

      useEffect(() => {
        
              get(child(dbref(rtdb), `codeofconduct`)).then((snapshot) => {
                if (snapshot.exists()) {
        
                  setText(snapshot.val().text)
                  setLoading(false);
        
                } else {
        
                  setText('<p></p>')
                  setLoading(false);
                  console.log("No data available");
                }
              }).catch((error) => {
                console.error(error);
              }); 
        
           
          }, [])

          if(loading){
            return (
              <Grid style={{ width: "100%", display: "flex", alignItems: "center",  flexDirection: "column"  }}>
                <Grid style={{ width: "100%", marginTop: 60, maxWidth: 1200, display: "flex", padding: 25, height: "80vh",
                flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <Box sx={{ display: 'flex' }}>
                    <CircularProgress color="inherit" />
                  </Box>
                </Grid>
              </Grid>
            );
          }

  return (
    <>
      <Helmet>
        <title> Code of Conduct | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid style={{top: 0, width: '100%',
        display: "flex",justifyContent: "center", alignItems: "center",  flexDirection: "column"  }}>

{matches ? <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
        width: "100%",
        display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
            <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                <source src={"/assets/videobg.mp4"} type='video/mp4' />
            </video>
          </Grid> : <Grid style={{ zIndex:-1, position: "fixed", top: 0,backgroundColor: '#1b0049', 
        
        height: "110vh",
        display: "flex", justifyContent: "flex-end", flexDirection: "column"  }}>
            <video height={"100%"} className='videoTag' playsInline autoPlay loop muted>
                <source src={"/assets/videobg.mp4"} type='video/mp4' />
            </video>
          </Grid>}
      

        <Grid style={{  maxWidth: 1200, zIndex:1, marginTop: 120, width: "100%", display: "flex", padding: 25,  paddingTop: 60, paddingBottom: 80,
            flexDirection: "column", justifyContent: "center", backgroundColor: "Transparent" }}>
            <Typography style={{ fontWeight: "bold", fontSize: 40, color: 'white', textTransform: "uppercase" }}>
            OneT code of conduct
            </Typography>
            <Typography style={{marginTop: -10, fontWeight: "lighter", fontSize: 16, color: 'white' }}>
            Our code reflects our basic guiding principles and sets the standard for acting with integrity at One T
            </Typography>
        </Grid>

        <Grid style={{ zIndex:1, backgroundColor: '#1b0049', width: "100%", display: "flex",justifyContent: "center", alignItems: "center",  
          flexDirection: "column" }}>
            <Grid style={{  padding: 25, maxWidth: 1200, marginTop: 10, width: "100%", display: "flex", alignItems: "center",
              flexDirection: "column",  backgroundColor: "Transparent" }}>
                <Typography style={{ textAlign: "center", fontWeight: "bold", fontSize: 36, color: 'White', textTransform: "uppercase" }}>
                Code of conduct
                </Typography>
                
                {parse(text)}

            </Grid>

        </Grid>
        
      </Grid>
    </>
  );
}
